<p-dialog
  styleClass="tf-plan-change-dialog"
  [modal]="true"
  [visible]="open()"
  [draggable]="false"
  [resizable]="false"
  [closable]="!isConfirming()"
  [header]="'SETTINGS_BILLING.PLAN_CARDS.DIALOG_TITLE' | translate"
  (visibleChange)="onDialogVisibleChange($event)">
  <p class="tf-plan-change-dialog__subtitle">
    {{ 'SETTINGS_BILLING.PLAN_CARDS.DIALOG_SUBTITLE' | translate }}
  </p>

  @if (currentPlan(); as current) {
    @if (targetPlan(); as target) {
      <section class="tf-plan-change-dialog__summary" aria-live="polite">
        <article class="tf-plan-change-dialog__plan">
          <span class="tf-plan-change-dialog__label">
            {{ 'SETTINGS_BILLING.PLAN_CARDS.CURRENT_PLAN_LABEL' | translate }}
          </span>
          <strong class="tf-plan-change-dialog__name">{{ current.name }}</strong>
          <span class="tf-plan-change-dialog__price">
            @if (currentPrice(); as price) {
              @if (isTranslationKey(price)) {
                {{ price | translate }}
              } @else {
                {{ price }}
              }
            }
            @if (currentPriceSuffix(); as suffix) {
              <span>
                @if (isTranslationKey(suffix)) {
                  {{ suffix | translate }}
                } @else {
                  {{ suffix }}
                }
              </span>
            }
          </span>
        </article>

        <div class="tf-plan-change-dialog__arrow" aria-hidden="true">
          <i class="pi pi-arrow-right"></i>
        </div>

        <article class="tf-plan-change-dialog__plan tf-plan-change-dialog__plan--target">
          <span class="tf-plan-change-dialog__label">
            {{ 'SETTINGS_BILLING.PLAN_CARDS.NEW_PLAN_LABEL' | translate }}
          </span>
          <strong class="tf-plan-change-dialog__name">{{ target.name }}</strong>
          <span class="tf-plan-change-dialog__price">
            @if (targetPrice(); as price) {
              @if (isTranslationKey(price)) {
                {{ price | translate }}
              } @else {
                {{ price }}
              }
            }
            @if (targetPriceSuffix(); as suffix) {
              <span>
                @if (isTranslationKey(suffix)) {
                  {{ suffix | translate }}
                } @else {
                  {{ suffix }}
                }
              </span>
            }
          </span>
        </article>
      </section>
    }
  }

  <div class="tf-plan-change-dialog__callout">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <span>
      {{ 'SETTINGS_BILLING.PLAN_CARDS.DIALOG_CALLOUT' | translate }}
      {{ 'SETTINGS_BILLING.PRICE_EXCLUDES_VAT' | translate }}
    </span>
  </div>

  @if (requiresBillingTerms()) {
    <label class="tf-plan-change-dialog__consent">
      <input
        type="checkbox"
        [checked]="consentAccepted()"
        [disabled]="isConfirming()"
        (change)="onConsentChange($event)" />
      <span>
        {{ 'SETTINGS_BILLING.PLAN_CARDS.BILLING_TERMS_PREFIX' | translate }}
        <a
          class="billing-link"
          href="https://tourfold.com/terms"
          target="_blank"
          rel="noopener noreferrer">
          {{ 'SETTINGS_BILLING.PLAN_CARDS.BILLING_TERMS_LINK' | translate }}
        </a>
        {{ 'SETTINGS_BILLING.PLAN_CARDS.BILLING_TERMS_SUFFIX' | translate }}
      </span>
    </label>
  }

  <ng-template #footer>
    <p-button
      severity="secondary"
      [outlined]="true"
      [label]="'SETTINGS_BILLING.PLAN_CARDS.DIALOG_CANCEL_BUTTON' | translate"
      [disabled]="isConfirming()"
      (onClick)="onCancel()" />
    <p-button
      [label]="'SETTINGS_BILLING.PLAN_CARDS.DIALOG_CONFIRM_BUTTON' | translate"
      [loading]="isConfirming()"
      [disabled]="!canConfirm()"
      (onClick)="onConfirm()" />
  </ng-template>
</p-dialog>
